module.exports = __webpack_public_path__ + "img/faqs.27cb3f69.svg";